module.exports = __webpack_public_path__ + "static/img/1009_big.8e72be2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1009_big.png
// module id = Jtdr
// module chunks = 1